import React from 'react';

const itFactorsData = [
  {
    id: 'creativity',
    title: 'Creativity',
    desc: (
      <>
        We bring fresh ideas and innovative tech solutions to every project. Our team uses creative problem solving to meet your unique business needs.
      </>
    ),
    topIcon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="8" width="36" height="26" rx="4" stroke="#94a3b8" strokeWidth="2.2" />
        <rect x="11" y="13" width="10" height="9" rx="1.5" stroke="#c40a0a" strokeWidth="1.8" />
        <path d="M25 14H36" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <path d="M25 18H33" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <path d="M11 27H36" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <path d="M18 34L14 40H34L30 34" stroke="#94a3b8" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    cornerIcon: (
      <svg width="120" height="120" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="corner-svg">
        <circle cx="50" cy="25" r="10" stroke="#ffffff" strokeWidth="3" />
        <path d="M43 23C43 23 46 27 50 27C54 27 57 23 57 23" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M30 55C30 45 40 40 50 40C60 40 70 45 70 55V68H30V55Z" stroke="#ffffff" strokeWidth="3" />
        <path d="M28 58L42 70L58 70L72 58" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M36 70L50 54L64 70" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 88L25 88L35 78L45 88L65 78L75 88L90 88" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'quality-working',
    title: 'Quality Working',
    desc: (
      <>
        We deliver reliable, high-standard services that focus on efficiency. Our skilled professionals ensure every task is completed with precision and care.
      </>
    ),
    topIcon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="12" stroke="#94a3b8" strokeWidth="2.2" />
        <path d="M29 29L40 40" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="20" cy="20" r="4.5" stroke="#c40a0a" strokeWidth="2" />
        <path d="M20 12V14M20 26V28M12 20H14M26 20H28" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
    cornerIcon: (
      <svg width="120" height="120" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="corner-svg">
        <circle cx="50" cy="24" r="10" stroke="#ffffff" strokeWidth="3" />
        <path d="M32 54C32 44 41 40 50 40C59 40 68 44 68 54V68H32V54Z" stroke="#ffffff" strokeWidth="3" />
        <circle cx="70" cy="62" r="12" stroke="#c40a0a" strokeWidth="3" fill="#000000" />
        <path d="M78 70L88 80" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" />
        <path d="M66 62L69 65L75 59" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 88L30 88L42 78L58 88L72 78L88 88" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'growth',
    title: 'Growth',
    desc: (
      <>
        Our IT and <a href="/bpo-services/" className="text-red hover-underline" style={{ color: '#c40a0a', fontWeight: 600, textDecoration: 'none' }}>BPO Services</a> help your business scale. We help you grow and expand your business with our IT services.
      </>
    ),
    topIcon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="24" width="7" height="16" rx="1.5" stroke="#94a3b8" strokeWidth="2.2" />
        <rect x="20" y="16" width="7" height="24" rx="1.5" stroke="#94a3b8" strokeWidth="2.2" />
        <rect x="32" y="8" width="7" height="32" rx="1.5" stroke="#c40a0a" strokeWidth="2.2" fill="rgba(196, 10, 10, 0.08)" />
        <path d="M28 8L35.5 1.5L43 8" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M35.5 2V10" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    ),
    cornerIcon: (
      <svg width="120" height="120" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="corner-svg">
        <circle cx="50" cy="24" r="10" stroke="#ffffff" strokeWidth="3" />
        <path d="M32 54C32 44 41 40 50 40C59 40 68 44 68 54V68H32V54Z" stroke="#ffffff" strokeWidth="3" />
        <path d="M25 45L15 35M20 55L8 50M24 65L12 65" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M42 70L50 56L58 70" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 88L28 88L40 78L56 88L70 78L88 88" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
];

function ItServicesDifferentiators() {
  return (
    <section className="dig-factors-section">
      <div className="container">
        {/* Centered Heading */}
        <h2 className="dig-factors-title">
          Factors Making Us <span className="text-red">Different From Others</span>
        </h2>

        {/* 3 Cards Grid with Hover Corner Icon */}
        <div className="dig-factors-grid">
          {itFactorsData.map((item) => (
            <div key={item.id} className="dig-factor-card">
              <div className="dig-factor-icon">
                {item.topIcon}
              </div>

              <h3 className="dig-factor-card-title">
                {item.title}
              </h3>

              <p className="dig-factor-card-desc">
                {item.desc}
              </p>

              {/* Bottom Right Hover Stick Icon */}
              <div className="dig-factor-corner-icon">
                {item.cornerIcon}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ItServicesDifferentiators;
